export default __webpack_public_path__ + "static/media/Icono_App_E-Hunter.4692ccd1.png";